<template>
  <LocaleLink v-slot="{ active }" :href="activeTabUrl">
    <slot :active="active"> {{ $t("workspace") }}</slot>
  </LocaleLink>
</template>

<script lang="ts" setup>
const { activeTabUrl } = useActiveTab();
</script>
